import React from "react";

import { SupStatusIndicator, SupTooltip } from "@repo/core-ui";

interface UiDetailsAtomStatusProps {
  auth?: boolean;
  logo?: string;
}

export default function UiDetailsAtomStatus({ auth, logo }: UiDetailsAtomStatusProps) {
  return (
    <SupTooltip
      wrapper
      color={auth ? "success" : "error"}
      unmount
      portal
      className="flex items-center"
      content={auth ? "The protocol is authenticated" : "This is an unauthenticated protocol. Be extremely careful when interacting with its vaults"}
      placement="top"
    >
      <SupStatusIndicator variant="post" icon={auth ? logo : ""} label={auth ? "AUTHENTICATED" : "UNAUTHENTICATED"} color={auth ? "success" : "error"} />
    </SupTooltip>
  );
}
